import { ACCOUNT_STATUS } from '@app/dashboard/constants/settings/profile-details';

export const getAccountStatus = ({
  test,
  live,
}: {
  test: string[];
  live: string[];
}) => {
  const hasLive = !!live.length;
  const hasTest = !!test.length;

  if (!hasLive && !hasTest) return ACCOUNT_STATUS.NO_INTEGRATION;

  if (hasLive) return ACCOUNT_STATUS.LIVE;

  return ACCOUNT_STATUS.TEST;
};
